import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { useContext, useEffect, useState } from "react";
import SchwingLogo from "../../../Images/Machines/Batching plant.png";
import dayjs from "dayjs";
import SchwingLogoIndia from "../../../Images/Machines/Batching plant.png";

const tableHeadings = [
  {
    bno: "Batch No.",
    bdate: "Batch Date",
    cid: "Customer ID",
    rid: "Recipe ID",
    qty: "Qty Production",
  },
];

const ProductionReport = ({ reportData, from, to }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfUrlCh, setPdfUrlCh] = useState(null);

  async function handleGeneratePDF() {
    const pdfDoc = await PDFDocument.create();
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const schwingIndia = "Schwing India";
    const fontSize = 8.5;
    const pageWidth = 595;
    const pageHeight = 842;
    const title = sessionStorage.getItem("comp_name");
    const fromDate = dayjs(from).format("DD-MM-YYYY");
    const toDate = dayjs(to).format("DD-MM-YYYY");

    const data = [];
    for (let y in reportData.data) {
      data.push(reportData.data[y]);
    }

    const x = 30;
    const y = pageHeight - (tableHeadings.length - 2) * fontSize;

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const pageCount = Math.ceil(data.length / 15);
    let rowY = pageHeight - (tableHeadings.length - 2) * fontSize;
    let rowY2 = y;
    const imageBytes = await fetch(SchwingLogo).then((res) =>
      res.arrayBuffer(),
    );

    const image = await pdfDoc.embedPng(imageBytes);

    const imageBytes1 = await fetch(SchwingLogoIndia).then((res) =>
      res.arrayBuffer(),
    );

    const image1 = await pdfDoc.embedPng(imageBytes1);
    let logo;

    try {
      const imageUrl = "https://placehold.co/600x400/png";

      if (!imageUrl)
        throw new Error("No image URL available in sessionStorage");

      const imageBytes = await fetch(imageUrl).then((res) => res.arrayBuffer());

      // Embed image based on its format
      if (imageUrl.includes("png")) {
        logo = await pdfDoc.embedPng(imageBytes);
      } else if (imageUrl.includes("jpeg") || imageUrl.includes("jpg")) {
        logo = await pdfDoc.embedJpg(imageBytes);
      } else {
        throw new Error(
          "Unsupported image format. Only PNG and JPG are allowed.",
        );
      }
    } catch (error) {
      console.error("Error embedding logo:", error);
    }

    for (let i = 0; i < pageCount; i++) {
      const startIndex = i * 25;
      const endIndex = Math.min(startIndex + 25, data.length); //sets how many rows should be rendered in one page
      const pageData = data.slice(startIndex, endIndex);

      if (pageData.length > 0) {
        //only if there is data the pdf will be generated
        rowY = 695;
        let page = pdfDoc.addPage([pageWidth, pageHeight]);
        let pageRowY = rowY;

        for (const element of pageData) {
          page.drawText(String(element?.b_no).toString(), {
            x: x + 5,
            y: pageRowY,
            font,
            size: fontSize,
          });
          page.drawText(element.b_Date.toString(), {
            x: x + 65,
            y: pageRowY,
            font,
            size: fontSize,
          });
          page.drawText(element.cust_id.toString(), {
            x: x + 140,
            y: pageRowY,
            font,
            size: fontSize,
          });
          page.drawText(element.recp_id.toString(), {
            x: x + 305,
            y: pageRowY,
            font,
            size: fontSize,
          });
          page.drawText(String(element?.qty).toString(), {
            x: x + 480,
            y: pageRowY,
            font,
            size: fontSize,
          });
          pageRowY -= 25;
        }

        if (endIndex === data.length) {
          let additionalRowY = Math.max(pageRowY);
          let total = 0;
          data.forEach((element) => {
            total += parseFloat(String(element?.qty));
          });

          const additionalRowX = x;
          page.drawText("Total : ", {
            x: additionalRowX + 440,
            y: additionalRowY - 3,
            font,
            size: 10,
          });
          page.drawText(total.toFixed(4), {
            x: additionalRowX + 480,
            y: additionalRowY - 3,
            font,
            size: 10,
          });
        }

        page.drawText("Total Production Details", {
          x: 220,
          y: 775,
          size: 12,
          font,
        });
        page.drawText("Plant Sl No.:", {
          x: 50,
          y: 757,
          size: 12,
          font,
        });

        page.drawText(String(reportData?.p_sl), {
          x: 130,
          y: 757,
          size: 12,
          font,
        });

        page.drawText("Plant Name:", {
          x: 50,
          y: 740,
          size: 12,
          font,
        });
        page.drawText(String(reportData?.p_t), {
          x: 130,
          y: 740,
          size: 12,
          font,
        });

        page.drawText("From Time:", {
          x: 400,
          y: 757,
          size: 12,
          font,
        });
        page.drawText(fromDate.toString(), {
          x: 470,
          y: 757,
          size: 12,
          font,
        });
        page.drawText("To Time:", {
          x: 400,
          y: 740,
          size: 12,
          font,
        });
        page.drawText(toDate.toString(), {
          x: 470,
          y: 740,
          size: 12,
          font,
        });

        tableHeadings &&
          tableHeadings.forEach((header, rowIndex) => {
            rowY2 = y - (rowIndex + 16) * fontSize;

            page.drawText(header.bno.toString(), {
              x: x,
              y: rowY2,
              font,
              size: fontSize + 2,
            });
            page.drawText(header.bdate.toString(), {
              x: x + 60,
              y: rowY2,
              font,
              size: fontSize + 2,
            });
            page.drawText(header.cid.toString(), {
              x: x + 170,
              y: rowY2,
              font,
              size: fontSize + 2,
            });
            page.drawText(header.rid.toString(), {
              x: x + 335,
              y: rowY2,
              font,
              size: fontSize + 2,
            });
            page.drawText(String(header?.qty).toString(), {
              x: x + 460,
              y: rowY2,
              font,
              size: fontSize + 2,
            });
          });

        const text = sessionStorage.getItem("comp_name");
        const textWidth = boldFont.widthOfTextAtSize(text, 15);
        const centerX = (pageWidth - textWidth) / 2;

        page.drawText(text, {
          x: centerX,
          y: 800,
          size: 15,
          font: boldFont,
        });

        if (sessionStorage.getItem("leftimage") === "1") {
          page.drawImage(image1, {
            x: 20,
            y: 790,
            width: 100,
            height: 40,
          });
        } else {
          page.drawImage(image, {
            x: 20,
            y: 800,
            width: 100,
            height: 30,
          });
        }

        // if (sessionStorage.getItem("footer") !== "") {
        //   const maxWidth = page.getWidth(); // Get the full page width
        //   const fontSize = 10;
        //   const footerText = sessionStorage.getItem("footer");
        //   const lineHeight = 12;

        //   // Calculate yPos for footer
        //   const yPos = 40;

        //   // Draw a full-width horizontal line above the footer
        //   page.drawLine({
        //     start: { x: 10, y: yPos + 15 }, // Start from left edge
        //     end: { x: maxWidth - 10, y: yPos + 15 }, // End at right edge
        //     thickness: 1,
        //     color: rgb(0, 0, 0), // Black line
        //   });

        //   // Draw the footer text
        //   page.drawText(footerText, {
        //     x: 30,
        //     y: yPos,
        //     size: fontSize,
        //     font: boldFont,
        //     maxWidth: maxWidth - 60, // Adjust to avoid text overflow
        //     lineHeight: lineHeight,
        //   });
        // }

        // if (sessionStorage.getItem("logo") === "1" && logo) {
        //   const imgDims = logo.scale(1); // gets native width & height in points

        //   const targetWidth = 60;
        //   const aspectRatio = imgDims.height / imgDims.width;
        //   const targetHeight = targetWidth * aspectRatio;

        //   page.drawImage(logo, {
        //     x: 490,
        //     y: 780,
        //     width: targetWidth,
        //     height: targetHeight,
        //   });
        // }

        //rendered lines to display as a teble for the data

        page.drawLine({
          start: { x: 150, y: pageRowY + 18 },
          end: { x: 150, y: 727 },
          thickness: 0.1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 79, y: pageRowY + 18 },
          end: { x: 79, y: 727 },
          thickness: 0.1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 320, y: pageRowY + 18 },
          end: { x: 320, y: 727 },
          thickness: 0.1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });

        page.drawLine({
          start: { x: 480, y: pageRowY + 18 },
          end: { x: 480, y: 727 },
          thickness: 0.1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 25, y: 728 },
          end: { x: 570, y: 728 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 25, y: 708 },
          end: { x: 570, y: 708 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 570, y: 728 },
          end: { x: 570, y: pageRowY + 18 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 25, y: 728 },
          end: { x: 25, y: pageRowY + 18 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
        page.drawLine({
          start: { x: 25, y: pageRowY + 18 },
          end: { x: 570, y: pageRowY + 18 },
          thickness: 1,
          color: rgb(0.5, 0.5, 0.5),
          opacity: 0.75,
        });
      }
    }

    // Save the PDF
    const pdfBytes = await pdfDoc.save();

    setPdfUrlCh(
      URL.createObjectURL(new Blob([pdfBytes], { type: "application/pdf" })),
    );
  }

  useEffect(() => {
    if (reportData) {
      handleGeneratePDF();
    }
  }, [reportData]);

  return (
    <Grid container spacing={2} alignItems='center'>
      {reportData && (
        <iframe
          src={pdfUrlCh}
          width='100%'
          height='600px'
          title='Batch Report PDF'
        />
      )}
    </Grid>
  );
};

export default ProductionReport;
